import React, {createRef} from "react";
import {useFormikContext} from "formik";
import {Grid} from '@mantine/core';
import MantineInputField from "../../../../FormikUtils/MantineInputField";
import MantineSelectField from "../../../../FormikUtils/MantineSelectField";
import MantineDateField from "../../../../FormikUtils/MantineDateField";
import PhoneInput from "react-phone-number-input";
import MantineInputRefField from "../../../../FormikUtils/MantineInputRefField";
import MantineAutoCompleteField from "../../../../FormikUtils/MantineAutoCompleteField";
import useStyles from "../../../CombinadoForm/Checkout/styles";

export default function TitularForm(props) {

    const {
        formField: {nombre, apellido, telefono,fechaNacimiento, cargaFamilia, numeroHijos, email, codigosLocalidad, dni},
        localidadesData
    } = props;
    const classes = useStyles();
    const ref = createRef();
    const {values, setFieldValue} = useFormikContext();

    const cargaFamiliaOptions = [
        {value: '0', label: 'Individual'},
        {value: '1', label: 'Matrimonio'},
    ];

    const numeroHijosOptions = [
        {value: '0', label: 'Sin hijos'},
        {value: '1', label: '1 hijo'},
        {value: '2', label: '2 hijos'},
        {value: '3', label: '3 hijos'},
        {value: '4', label: '4 hijos'},
        {value: '5', label: '5 hijos'},
        {value: '6', label: 'Más de 5 hijos'},
    ];

    return (
        <React.Fragment>
            <Grid gutter="md" justify="center" align="center">
                <Grid.Col xs={12} sm={6}>
                    <MantineInputField
                        name={nombre.name}
                        label={nombre.label}
                        withAsterisk
                    />
                </Grid.Col>
                <Grid.Col xs={12} sm={6}>
                    <MantineInputField
                        name={apellido.name}
                        label={apellido.label}
                        withAsterisk
                    />
                </Grid.Col>
                <Grid.Col xs={12} sm={6}>
                    <MantineInputField
                        name={dni.name}
                        label={dni.label}
                        withAsterisk
                    />
                </Grid.Col>
                <Grid.Col xs={12} sm={6}>
                    <MantineDateField
                        name={fechaNacimiento.name}
                        label={fechaNacimiento.label}
                    />
                </Grid.Col>
                <Grid.Col xs={12} sm={6}>
                    <MantineSelectField
                        name={cargaFamilia.name}
                        label={cargaFamilia.label}
                        data={cargaFamiliaOptions}
                        withAsterisk
                    />
                </Grid.Col>
                <Grid.Col xs={12} sm={6}>
                    <MantineSelectField
                        name={numeroHijos.name}
                        label={numeroHijos.label}
                        data={numeroHijosOptions}
                        withAsterisk
                    />
                </Grid.Col>
                <Grid.Col xs={12} sm={12}>
                    <MantineInputField
                        name={email.name}
                        label={email.label}
                        withAsterisk
                    />
                </Grid.Col>
                <Grid.Col xs={12} sm={6}>
                    <div className={classes.field}>
                        <PhoneInput
                            defaultCountry="AR"
                            ref={ref}
                            inputComponent={MantineInputRefField}
                            name={telefono.name}
                            label={telefono.label}
                            value={values.telefono}
                            onChange={(e) => {
                                /** @namespace e.length **/
                                if (e && e.length > 12) {
                                    setFieldValue(telefono.name, e)
                                }
                            }}
                            withAsterisk
                        />
                    </div>
                </Grid.Col>
                <Grid.Col xs={12} sm={6}>
                    <MantineAutoCompleteField
                        name={codigosLocalidad.name}
                        label={codigosLocalidad.label}
                        data={localidadesData}
                        searchable
                        withAsterisk
                    />
                </Grid.Col>
            </Grid>
        </React.Fragment>
    );
}
